module.exports = {
  InsureNo: 'หมายเลขแบบฟอร์มประกันภัย',
  PolicyNo: 'หมายเลขกรมธรรม์',
  TheInsured: 'ผู้เอาประกันภัย',
  DateOfShipment: 'วันที่เริ่มขนส่ง',
  PlaceOfOrigin: 'จุดเริ่มต้นการขนส่ง',
  Destination: 'จุดหมายปลายทาง',
  BillOfLoadingNo: 'หมายเลขใบตราส่งสินค้า',
  Premium: 'เบี้ยประกันภัย',
  SubmissionTime: 'เวลาส่งข้อมูล',
  DeliveryTime: 'เวลาออกกรมธรรม์',
  DeliveryStatus: 'สถานะการออกกรมธรรม์',
  Operation: 'การดำเนินการ',
  EditPolicy: 'แก้ไขกรมธรรม์',
  DeletePolicy: 'ลบกรมธรรม์',
  DownloadPolicy: 'ดาวน์โหลดกรมธรรม์',
  CancellationOfPolicy: 'ยกเลิกกรมธรรม์',
  ReIssuePolicy: 'ออกกรมธรรม์ใหม่',
  InvoiceNo: 'หมายเลขใบแจ้งหนี้',
  PlaceOfOriginForSea: 'จุดเริ่มต้นการขนส่งทางทะเล',
  PlaceOfOriginForAir: 'จุดเริ่มต้นการขนส่งทางอากาศ',
  SeaportDestination: 'จุดหมายปลายทางทางทะเล',
  AirportDestination: 'จุดหมายปลายทางทางอากาศ',
  N1CompleteInsuranceInformation: '1 กรอกข้อมูลกรมธรรม์',
  N3PreviewAndConfirm: '3 ตรวจสอบก่อนยืนยัน',
  Insured: 'ผู้เอาประกันภัย',
  EmailRecipient: 'ผู้รับอีเมล',
  GoodsCategory: 'ประเภทสินค้า',
  GoodsName: 'ชื่อสินค้า',
  MarksAndNumbers: 'เครื่องหมายสินค้า',
  BillOfLadingNumber: 'หมายเลขใบตราส่งสินค้า',
  BillOfLadingDate: 'วันที่ใบตราส่งสินค้า',
  InvoiceNumber: 'หมายเลขใบแจ้งหนี้',
  ContractNumber: 'หมายเลขสัญญา',
  VesselVoyagevehiclePlateNumberflightNumber: 'ชื่อเรือ/หมายเลขทะเบียนรถ/หมายเลขเที่ยวบิน',
  TransportationType: 'ประเภทการขนส่ง',
  Domestic: 'ภายในประเทศ',
  Import: 'นำเข้า',
  Export: 'ส่งออก',
  TransportationMode: 'วิธีการขนส่ง',
  InlandTransportationTools: 'ยานพาหนะขนส่งภายในประเทศ',
  PlaceOfDepartureport: 'จุดเริ่มต้นการขนส่ง (ท่าเรือ)',
  DepartureDate: 'วันที่เริ่มขนส่ง',
  TransitPlaceport: 'จุดพักขนส่ง (ท่าเรือ)',
  Destinationport: 'จุดหมายปลายทาง (ท่าเรือ)',
  InlandStartingPoint: 'จุดเริ่มต้นการขนส่งภายในประเทศ',
  TradeTerms: 'เงื่อนไขการค้า',
  InvoiceAmount: 'จำนวนเงินในใบแจ้งหนี้',
  MainInsurance: 'ความคุ้มครองหลัก',
  LetterOfCreditConditionNumber: 'หมายเลขเงื่อนไขเลตเตอร์ออฟเครดิต',
  ClaimsAgentPoint: 'จุดตัวแทนเรียกร้องค่าชดเชย',
  Insured2: 'ผู้เอาประกันภัย:',
  PolicyHolder: 'ผู้ถือกรมธรรม์:',
  EndDateOfInsurance: 'วันที่สิ้นสุดประกัน:',
  DateOfInsurance: 'วันที่ทำประกัน:',
  DateOfEntry: 'วันที่บันทึกข้อมูล:',
  MainClause: 'ข้อกำหนดหลัก:',
  GoodsName2: 'ชื่อสินค้า:',
  InsurancePremium: 'เบี้ยประกัน:',
  InsuranceAmounttotalLimit: 'จำนวนเงินประกัน/วงเงินรวม:',
  FinalRate: 'อัตราเบี้ยประกันขั้นสุดท้าย%:',
  AddProportion: 'อัตราส่วนเพิ่ม%:',
  InsuranceApplicationNumber: 'เลขที่ใบคำขอประกัน:',
  PolicyStatus: 'สถานะกรมธรรม์:',
  InsuranceStartDate: 'วันที่เริ่มคุ้มครอง:',
  ReviewDate: 'วันที่ตรวจสอบ:',
  UnderwritingDate: 'วันที่รับประกัน:',
  CompleteInsuranceInformation: 'กรอกข้อมูลกรมธรรม์',
  Inquire: 'สอบถามราคา',
  PreviewAndConfirm: 'ตรวจสอบก่อนยืนยัน',
  InsuranceCompleted: 'ทำประกันเสร็จสิ้น',
  CancellationReason: 'เหตุผลการยกเลิก',
  PolicyHolderInformation: 'ข้อมูลผู้ถือกรมธรรม์',
  SameAsPolicyHolder: 'เหมือนผู้ถือกรมธรรม์',
  GoodsInformation: 'ข้อมูลสินค้า',
  TransportationInformation: 'ข้อมูลการขนส่ง',
  InsuranceAmountInformation: 'ข้อมูลจำนวนเงินประกัน',
  InsuranceConditions: 'เงื่อนไขประกัน',
  FreightInsurance: 'ประกันภัยขนส่งสินค้า',
  WPA: 'ประกันภัยน้ำรั่วซึม',
  FPA: 'ประกันภัยภัยธรรมดา',
  AllRiskForRefrigeratedGoods: 'ประกันภัยความเสี่ยงทั้งหมดสำหรับสินค้าแช่เย็น',
  RefrigeratedInsurance: 'ประกันภัยสินค้าแช่เย็น',
  OtherInformation: 'ข้อมูลอื่นๆ',
  InsuranceInstructions: 'คำอธิบายการทำประกัน',
  TheInstitutionsWithTechnicalLtd: 'ผลิตภัณฑ์ประกันภัยที่แสดงบนแพลตฟอร์มนี้จัดจำหน่ายโดยสถาบันการเงินประกันภัย และได้รับบริการทางเทคนิคจากโตเกียวมารีน แอนด์ นิชิโด ไฟร์ แอนด์ มารีน อินชัวรันส์ (จีน) จำกัด',
  PremiumAmount: 'จำนวนเบี้ยประกัน',
  ShanghaiStorageAndTransportationLtd: 'บริษัทเซี่ยงไฮ้ จิ้งเหม่า ชานจิ่ว โลจิสติกส์ จำกัด',
  SuccessfullyInsured: 'ทำประกันสำเร็จ!',
  PolicyNumber: 'เลขที่กรมธรรม์:',
  TemporarySave: 'บันทึกชั่วคราว',
  PreviewAndContinue: 'ตรวจสอบและดำเนินการต่อ',
  Back: 'กลับ',
  PurchaseInsurance: 'ทำประกัน',
  Submitted: 'ส่งแล้ว',
  SavedSuccessfully: 'บันทึกชั่วคราวสำเร็จ',
  PleaseNameOfTheCompany: 'กรุณากรอกชื่อบริษัทเจ้าของสินค้า!',
  PleaseEmailSeparateMultipleSemicolons: 'กรุณากรอกผู้รับอีเมล! หากมีหลายคนให้คั่นด้วยเครื่องหมายอัฒภาคภาษาอังกฤษ!',
  PleaseGeneralCategoryOfGoods: 'กรุณากรอกประเภทสินค้า!',
  PleaseTheNameOfGoods: 'กรุณากรอกชื่อสินค้า!',
  PleaseInTheInvoiceNumber: 'กรุณากรอกเลขที่ใบแจ้งหนี้',
  TheShippingMarkCannotCharacters: 'ความยาวของเครื่องหมายไม่ควรเกิน 3000 ตัวอักษร!',
  TheCannotExceed40Characters: 'หมายเลขใบแจ้งหนี้ไม่ควรเกิน 40 ตัวอักษร!',
  BillNumberCannotExceedCharacters: 'หมายเลขใบตราส่งไม่ควรเกิน 100 ตัวอักษร!',
  ContractCannotExceed100Characters: 'หมายเลขสัญญาไม่ควรเกิน 100 ตัวอักษร!',
  PleaseVoyageNumberLicenseNumber: 'กรุณากรอกชื่อเรือ/หมายเลขทะเบียนรถ/หมายเลขเที่ยวบิน',
  PleaseEnterTheTransportationType: 'กรุณากรอกประเภทการขนส่ง',
  PleaseEnterTheTransportationMode: 'กรุณากรอกวิธีการขนส่ง',
  PleasePlaceOfDepartureport: 'กรุณากรอกสถานที่เริ่มต้นขนส่ง (ท่าเรือ)',
  PleaseEnterTheDestinationport: 'กรุณากรอกสถานที่ปลายทาง (ท่าเรือ)',
  PleaseEnterTheDepartureDate: 'กรุณากรอกวันที่เริ่มต้นขนส่ง',
  PleaseEnterTheTradeTerms: 'กรุณากรอกข้อตกลงทางการค้า!',
  PleaseEnterTheInvoiceAmount: 'กรุณากรอกจำนวนเงินในใบแจ้งหนี้!',
  PleaseEnterTheInvoiceCurrency: 'กรุณากรอกสกุลเงินในใบแจ้งหนี้',
  PleaseTheClaimAgencyPoint: 'กรุณากรอกจุดตัวแทนการเรียกร้องค่าชดเชย',
  PleaseAgreeToTheNotice: 'กรุณาอ่านและยอมรับ "หนังสือแจ้งลูกค้า"!',
  PolicyManagement: 'การจัดการกรมธรรม์',
  QuickSearchPolicyNumber: 'ค้นหาด่วน: หมายเลขกรมธรรม์',
  Cancellation: 'ยกเลิก',
  TotalPremium: 'เบี้ยประกันรวม:',
  PleaseInTheCancellationReason: 'กรุณากรอกเหตุผลในการยกเลิก',
  YouPermissionToEditPolicy: 'คุณไม่มีสิทธิ์แก้ไขกรมธรรม์',
  YouPermissionToDeletePolicy: 'คุณไม่มีสิทธิ์ลบกรมธรรม์',
  DeletingThePolicyRecordContinue: 'หลังจากลบจะล้างบันทึกกรมธรรม์ ต้องการดำเนินการต่อหรือไม่?',
  Confirm: 'ยืนยัน',
  InsurancePolicyNumber: 'หมายเลขใบขอเอาประกันภัย',
  Deleted: 'ลบแล้ว',
  YouPermissionToCancelPolicy: 'คุณไม่มีสิทธิ์ยกเลิกกรมธรรม์',
  PolicyNumber2: 'หมายเลขกรมธรรม์',
  Canceled: 'ยกเลิกแล้ว',
  YouPermissionToReissuePolicy: 'คุณไม่มีสิทธิ์ออกกรมธรรม์ใหม่',
  YouBeforeAndCannotAgain: 'คุณได้ออกใหม่แล้ว ไม่สามารถออกซ้ำได้!',
  InsuranceInstructionsTip: 'ข้าพเจ้าได้อ่านและยอมรับ "หนังสือแจ้งลูกค้า", "คำแถลงการขอเอาประกันภัย", "ข้อตกลงการใช้แพลตฟอร์ม", "เงื่อนไขกรมธรรม์ประกันภัย" เป็นอย่างดี และเข้าใจรวมถึงยอมรับข้อตกลงต่าง ๆ รวมถึงข้อกำหนดความรับผิดชอบ ข้อกำหนดการยกเว้นความรับผิดชอบ ข้อจำกัดประเภทสินค้าที่รับประกัน และข้อจำกัดมูลค่าสินค้าที่รับประกัน',
  InsuranceAgent: 'ตัวแทนประกันภัย',
  InsuranceCompany: 'บริษัทประกันภัย',
  InvoiceCurrency: 'สกุลเงินใบแจ้งหนี้',
  InsuranceAmount: 'จำนวนเงินเอาประกันภัย',
  InsuranceCurrency: 'สกุลเงินเอาประกันภัย',
  PremiumCurrency: 'สกุลเงินเบี้ยประกันภัย',
  Rate: 'อัตราเบี้ยประกันภัย',
  Waybillno: 'หมายเลขใบตราส่ง (หลัก)',
  InsureOrderUser: 'การดำเนินการใบขอเอาประกันภัย',
  PolicyUser: 'การดำเนินการกรมธรรม์',
  ReconciliationUser: 'การดำเนินการตรวจสอบยอด',
  PolicySyncStatus: 'สถานะการซิงค์กรมธรรม์',
  PremiumSyncStatus: 'สถานะการซิงค์เบี้ยประกันภัย',
  StartDate: 'วันที่เริ่มคุ้มครอง',
  EndDate: 'วันที่สิ้นสุดคุ้มครอง',
  FreightInsuranceFirstPage: 'หน้าหลักประกันภัยการขนส่งสินค้า',
  LiabilityInsuranceHomepage: 'หน้าหลักประกันภัยความรับผิด',
  LiabilityInsurance: 'ประกันภัยความรับผิด',
  BillingManagement: 'การจัดการบิล',
  Scanning: 'ดูอย่างรวดเร็ว',
  Specification: 'คำอธิบายพิเศษ',
  ServiceAdvantages: 'จุดเด่นของบริการ',
  InsuranceType: 'ประเภทประกันภัย',
  BillQuery: 'ตรวจสอบบิล',
  InvoiceDownload: 'ดาวน์โหลดใบแจ้งหนี้',
  ViewPolicy: 'ดูกรมธรรม์',
  PolicyDownload: 'ดาวน์โหลดกรมธรรม์',
  AddInquiryQuestionnaire: 'เพิ่มแบบสอบถามขอราคา',
  EditOrViewQuestionnaire: 'แก้ไข/ดูแบบสอบถาม',
  QuestionnaireStatus: 'สถานะแบบสอบถาม',
  PolicyStatus2: 'สถานะกรมธรรม์',
  LiabilityInsuranceInquiry: 'แบบสอบถามขอราคาประกันความรับผิดชอบตัวแทนจัดส่งสินค้า',
  InquiryForQuestionnaireContent: '*เนื้อหาแบบสอบถามนี้ใช้เฉพาะสำหรับการขอราคาประกันความรับผิดชอบเท่านั้น บริษัทโวฮังและบริษัทบุคคลที่สามจะรักษาความลับอย่างเคร่งครัด',
  AfterFillingQuestionnaire: '*หลังจากกรอกแบบสอบถามนี้ บุคคลที่สามจะติดต่อกลับทางเบอร์โทรศัพท์ที่ระบุไว้ภายใน 24 ชั่วโมง',
  ServiceProviderSelection: 'เลือกผู้ให้บริการ:',
  ApplicantInformation: 'ข้อมูลผู้ขอ:',
  RegisteredAndBusiness: 'ชื่อจดทะเบียนและชื่อทางการค้าของบริษัท (ถ้ามี):',
  InquiryQuestionnaire: 'แบบสอบถามขอราคา',
  ServiceProviderReply: 'คำตอบจากผู้ให้บริการ',
  ServiceProviderReply2: 'คำตอบจากผู้จัดหา',
  RegisteredName: 'ชื่อจดทะเบียน',
  RegisteredAddress: 'ที่อยู่จดทะเบียน',
  BusinessName: 'ชื่อทางการค้า',
  BusinessAddress: 'ที่อยู่ทางการค้า',
  RecoveryTime: 'เวลาตอบกลับ:',
  ReplyContent: 'เนื้อหาการตอบกลับ:',
  ExistInsuranceReocordContinue: 'ใบตราส่งนี้มีบันทึกการทำประกันอยู่แล้ว ต้องการดำเนินการต่อหรือไม่',
  TheInsuranceHasExist: 'ทำประกันแล้วไม่สามารถทำประกันซ้ำได้',
  CreatedNewInsureForm: 'สร้างกรมธรรม์ใหม่',
  ToViewOriginalApplication: 'ดูกรมธรรม์เดิม กรุณาไปที่',
  Insurance: 'ประกันภัย',
  Tab: 'แท็บ',
  EditViewInsuranceForm: 'แก้ไข/ดูกรมธรรม์',
  Deductible: 'จำนวนเงินที่ยกเว้นความรับผิด',
  InsuranceCoverage: 'ขอบเขตความคุ้มครอง',
  SpecialInstructions: 'คำอธิบายพิเศษ',
  ClaimsService: 'บริการเคลมประกัน',
  ServiceProviderIntroduction: 'แนะนำผู้ให้บริการ',
  SpecialCargo: 'สินค้าพิเศษ',
  CargoExclusion: 'สินค้าที่ไม่รวมอยู่ในความคุ้มครอง',
  SpecialAgreement: 'ข้อตกลงพิเศษ',
  ChooseServiceProvider: 'เลือกผู้ให้บริการ',
  ViewInsurancePolicy: 'ดูกรมธรรม์ในหน้าประกันภัย',
  RememberOperationDirectly: 'จำการดำเนินการนี้ไว้ ครั้งต่อไปจะทำประกันโดยตรง',
  ProductValue: 'มูลค่าสินค้า',
  Charges: 'อัตราค่าบริการ',
  MaximumIndemnityNorm: 'วงเงินชดเชย',
  SupplierResponse: 'คำตอบจากผู้จัดหา',
  UploadedFileUnRemove: 'ไม่อนุญาตให้ลบไฟล์ที่อัปโหลดแล้ว!',
  NoCorrespondingTemplate: 'ไม่พบเทมเพลตที่เกี่ยวข้อง!',
  NotAllowDeleteSubmited: 'ไม่อนุญาตให้ลบประวัติการทำประกันที่【ส่งแล้วและออกกรมธรรม์แล้ว】 กรุณาเลือกใหม่!',
  OnlyFileDocAndPdf: 'สามารถอัปโหลดไฟล์ที่มีนามสกุล【doc, docx, pdf】เท่านั้น กรุณาเลือกใหม่!',
  ToInsure: 'ทำประกัน:',
  FillInsuranceInformation: 'กรอกข้อมูลการทำประกัน',
  ClickToDownloadTemplate: 'คลิกดาวน์โหลดเทมเพลตและกรอกข้อมูลตามรูปแบบ',
  DragFile: 'ลากไฟล์มาที่นี่ หรือ',
  ClickToUpload: 'คลิกอัปโหลด'
}
